// 商户管理
const storelevel = () => import("@/components/platform/operation/storelevel");
const addStorelevel = () =>
  import("@/components/platform/operation/addStorelevel");
const serviceManagement = () =>
  import("@/components/platform/operation/serviceManagement");
const addService = () => import("@/components/platform/operation/addService");
const businessManagement = () =>
  import("@/components/platform/operation/businessManagement");
const addBusiness = () => import("@/components/platform/operation/addBusiness"); //新增添加商户
const corpSet = () => import("@/components/platform/operation/corpSet");
const businessExamine = () =>
  import("@/components/platform/operation/businessExamine"); //新增商户审核
const buyRecord = () => import("@/components/platform/operation/buyRecord");
const monthlyCloseProducts = () =>
  import("@/components/platform/operation/monthlyCloseProducts"); //1.8月结产品

const shopIndent = () => import("@/components/platform/operation/shopIndent");
const accretionIndent = () =>
  import("@/components/platform/operation/accretionIndent");

const buyServiceForUser = () =>
  import("@/components/platform/operation/buyServiceForUser");
const hostInfo = () => import("@/components/platform/operation/hostInfo");
const taxAudit = () => import("@/components/platform/operation/taxAudit");

const tenantRights = () =>
  import("@/components/platform/operation/rights/index"); // 商户权益
const renewManage = () => import("@/components/platform/operation/renew/index"); // 续费管理

// 渠道商户管理
const tenantManage = () => import("@/components/platform/tenant/tenantManage");
// 标签数据仓库
const merchantDataImport = () =>
  import("@/components/platform/merchantDataImport/index");
// 商户数据导入
const labelDataStore = () => import("@/components/labelDataStore/index");
//平台-渠道商
const channelsManage = () =>
  import("@/components/platform/channels/channelsManage");
const addChannels = () => import("@/components/platform/channels/addChannels");
const gradeManage = () => import("@/components/platform/channels/gradeManage");
const auditRecords = () =>
  import("@/components/platform/channels/auditRecords");
const partnershipCoin = () =>
  import("@/components/platform/channels/partnershipCoin"); //渠道合伙币

//渠道订单管理
const orderChannels = () =>
  import("@/components/platform/channels/orderChannels");
const ditchShopIndent = () =>
  import("@/components/platform/channels/ditchShopIndent");
const ditchAccretionIndent = () =>
  import("@/components/platform/channels/ditchAccretionIndent");
// 平台-商户授权
const merchantImpower = () => import("@/components/platform/impower/index");

// 平台-工厂管理
const factoryOrderManagement = () =>
  import("@/components/platform/factoryManagement/orderManagement/index");
const factoryManagement = () =>
  import("@/components/platform/factoryManagement/factory/index");
const factoryBuyProduct = () =>
  import("@/components/platform/factoryManagement/buyProduct");
//平台个人商城
const personalMall = () => import("@/components/cardMall/personalMall");
const personalMalls = () => import("@/components/platform/personalMall/index");
// 商户统计 活跃度统计
const liveness = () =>
  import("@/components/platform/statistics/liveness/index");

// 客户增值 风险报告
const riskReport = () =>
  import("@/components/platform/customerAppreciation/riskReport");

// 任务管理 - 标签任务
const tagTask = () => import("@/components/platform/taskManage/tagTask");

export default [
  {
    path: "/storelevel",
    meta: {
      text: "店铺等级设置",
    },
    name: "storelevel",
    component: storelevel,
  },
  {
    path: "/monthlyCloseProducts",
    meta: {
      text: "月结产品",
    },
    name: "monthlyCloseProducts",
    component: monthlyCloseProducts,
  },
  {
    path: "/addStorelevel",
    meta: {
      text: "添加店铺等级",
    },
    name: "addStorelevel",
    component: addStorelevel,
  },
  {
    path: "/serviceManagement",
    meta: {
      text: "增值服务管理",
    },
    name: "serviceManagement",
    component: serviceManagement,
  },
  {
    path: "/addService",
    meta: {
      text: "添加增值服务",
    },
    name: "addService",
    component: addService,
  },
  {
    path: "/corpSet",
    meta: {
      text: "商户设置",
    },
    name: "corpSet",
    component: corpSet,
  },
  {
    path: "/businessManagement",
    meta: {
      text: "商户管理",
    },
    name: "businessManagement",
    component: businessManagement,
  },
  {
    path: "/addBusiness",
    meta: {
      text: "添加商户",
    },
    name: "addBusiness",
    component: addBusiness,
  },
  {
    path: "/businessExamine",
    meta: {
      text: "商户审核",
    },
    name: "businessExamine",
    component: businessExamine,
  },
  {
    path: "/buyRecord",
    meta: {
      text: "商户购买记录",
    },
    name: "buyRecord",
    component: buyRecord,
  },
  {
    path: "/shopIndent",
    meta: {
      text: "店铺订单",
    },
    name: "shopIndent",
    component: shopIndent,
  },
  {
    path: "/accretionIndent",
    meta: {
      text: "增值订单",
    },
    name: "accretionIndent",
    component: accretionIndent,
  },
  {
    path: "/buyServiceForUser",
    meta: {
      text: "购买产品",
    },
    name: "buyServiceForUser",
    component: buyServiceForUser,
  },
  {
    path: "/hostInfo",
    meta: {
      text: "商户托管信息",
    },
    name: "hostInfo",
    component: hostInfo,
  },
  {
    path: "/taxAudit",
    meta: {
      text: "税盘审核",
    },
    name: "taxAudit",
    component: taxAudit,
  },
  {
    path: "/tenantManage",
    meta: {
      text: "渠道商户管理",
    },
    name: "tenantManage",
    component: tenantManage,
  },
  {
    path: "/merchantDataImport",
    meta: {
      text: "商户数据导入",
    },
    name: "merchantDataImport",
    component: merchantDataImport,
  },
  {
    path: "/labelDataStore",
    meta: {
      text: "标签数据仓库",
    },
    name: "labelDataStore",
    component: labelDataStore,
  },

  //渠道商
  {
    path: "/orderChannels",
    meta: {
      text: "订单管理",
    },
    name: "orderChannels",
    component: orderChannels,
  },
  {
    path: "/ditchShopIndent",
    meta: {
      text: "渠道店铺订单",
    },
    name: "ditchShopIndent",
    component: ditchShopIndent,
  },
  {
    path: "/ditchAccretionIndent",
    meta: {
      text: "渠道增值订单",
    },
    name: "ditchAccretionIndent",
    component: ditchAccretionIndent,
  },
  {
    path: "/channelsManage",
    meta: {
      text: "渠道商管理",
    },
    name: "channelsManage",
    component: channelsManage,
  },
  {
    path: "/partnershipCoin",
    meta: {
      text: "渠道合伙币",
    },
    name: "partnershipCoin",
    component: partnershipCoin,
  },
  {
    path: "/addChannels",
    meta: {
      text: "添加渠道商",
    },
    name: "addChannels",
    component: addChannels,
  },
  {
    path: "/gradeManage",
    meta: {
      text: "等级管理",
    },
    name: "gradeManage",
    component: gradeManage,
  },
  {
    path: "/auditRecords",
    meta: {
      text: "优惠审核记录",
    },
    name: "auditRecords",
    component: auditRecords,
  },
  {
    path: "/merchantImpower",
    name: "merchantImpower",
    meta: {
      text: "商户授权",
    },
    component: merchantImpower,
  },
  {
    path: "/factoryManagement",
    name: "factoryManagement",
    meta: {
      text: "工厂管理",
    },
    component: factoryManagement,
  },
  // 工厂管理的
  {
    path: "/factoryOrderManagement",
    meta: {
      text: "工厂订单",
    },
    name: "factoryOrderManagement",
    component: factoryOrderManagement,
  },
  {
    path: "/factoryBuyProduct",
    meta: {
      text: "购买产品",
    },
    name: "factoryBuyProduct",
    component: factoryBuyProduct,
  },
  {
    path: "/personalMall",
    name: "personalMall",
    meta: {
      text: "个人商城",
    },
    component: personalMall,
  },
  {
    path: "/personalMalls",
    name: "personalMalls",
    meta: {
      text: "个人商城",
    },
    component: personalMalls,
  },
  {
    path: "/liveness",
    name: "liveness",
    meta: {
      text: "活跃度统计",
      belong: ["client"],
    },
    component: liveness,
  },
  {
    path: "/tenantRights",
    meta: {
      text: "商户权益",
      belong: ["client"],
    },
    name: "tenantRights",
    component: tenantRights,
  },
  {
    path: "/renewManage",
    meta: {
      text: "续费管理",
      belong: ["client"],
    },
    name: "renewManage",
    component: renewManage,
  },
  {
    path: "/riskReport",
    meta: {
      text: "风险报告",
    },
    name: "riskReport",
    component: riskReport,
  },
  {
    path: "/tagTask",
    name: "tagTask",
    meta: {
      text: "标签任务",
      belong: ["client"],
    },
    component: tagTask,
  },
];
